module.exports = __webpack_public_path__ + "static/media/footer-tab.21e97720.png";